import { Packer } from "docx"
import { saveAs } from "file-saver"
import { FileText } from "lucide-react"

import { Button } from "@ui/button"
import { generateMarkdownFromMapping, markdownToDocx } from "@/lib/file"

interface DownloadAsDocxButtonProps {
    content: string | object
    filename: string
    mapping: Record<string, string>
}
export function DownloadAsDocxButton({ content, filename, mapping }: Readonly<DownloadAsDocxButtonProps>) {
    const handleDonwload = async () => {
        const value = typeof content === "object" ? JSON.stringify(content, null, 2) : String(content)
        const markdown = generateMarkdownFromMapping(JSON.parse(value), mapping)

        const doc = markdownToDocx(markdown)
        const blob = await Packer.toBlob(doc)
        saveAs(blob, `${filename}.docx`)
    }

    return (
        <Button onClick={handleDonwload}>
            <FileText />
            Export as Docx
        </Button>
    )
}